import React from "react";

const SearchCenter = props => {
  return <span>In Bearbeitung</span>;
};

export default SearchCenter;
